import { SVGProps } from 'react';

const Sandwich = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25M21 15a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m18 0H3m0 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9m-5.33-4 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2"
    />
  </svg>
);
export default Sandwich;
